import React from 'react';
import { Tab, Tabs } from '@material-ui/core';
import styles from './style.module.scss';

export const TabButtons = ({
  tabList,
  activeTab,
  onSelectTab,
  children,
}: {
  tabList: TabList;
  activeTab: string;
  onSelectTab: (value: string) => void;
  children: React.ReactNode;
}) => {
  return (
    <div className={styles.pdpOmniTabsContainer}>
      <Tabs
        value={activeTab}
        classes={{
          root: styles.pdpOmniTabsRoot,
          indicator: styles.pdpOmniTabsIndicator,
          flexContainer: styles.pdpOmniTabsFlexContainer,
        }}
      >
        {tabList.map((tab) => (
          <Tab
            key={tab.value}
            disableRipple
            classes={{
              root: styles.pdpOmniTabRoot,
              selected: styles.pdpOmniTabSelected,
            }}
            fullWidth={true}
            label={<span className="body uppercase semibold">{tab.label}</span>}
            value={tab.value}
            onClick={() => {
              onSelectTab(tab.value);
            }}
          />
        ))}
      </Tabs>
      <div className={styles.pdpOmniTabPanel}>{children}</div>
    </div>
  );
};

export type TabList = Array<{
  label: string;
  value: string;
}>;
